var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareAndroid = function SvgShareAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2.842 4.815a4 4 0 1 0-1.008-1.727L8.842 9.185a4 4 0 1 0 0 5.63l5.309 3.093A4.003 4.003 0 0 0 18 23a4 4 0 1 0-2.839-6.818l-5.31-3.095a4 4 0 0 0 0-2.175zM7.7 10.945a1 1 0 0 0 .056.096c.155.285.244.612.244.959a2 2 0 0 1-.3 1.055A1.999 1.999 0 0 1 4 12a2 2 0 0 1 3.7-1.055m8.515 7.151a1 1 0 0 0 .123-.209 2 2 0 1 1-.122.209",
    clipRule: "evenodd"
  })));
};
export default SvgShareAndroid;